module.exports = __webpack_public_path__ + "media/images/memo-317136ad17e50566d9df210072f0abda.svg";